//! Common
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SCREEN_SCROLL = 'SET_SCREEN_SCROLL';

//! Web
export const GET_REPORTS = 'GET_REPORTS';
export const SET_REPORTS = 'SET_REPORTS';

//! Site Settings
export const GET_SITE_SETTINGS = 'GET_SITE_SETTINGS';
export const SET_SITE_SETTINGS = 'SET_SITE_SETTINGS';

//! Awards
export const GET_AWARDS = 'GET_AWARDS';
export const SET_AWARDS = 'SET_AWARDS';

//! Media Coverage
export const GET_MEDIA_COVERAGE = 'GET_MEDIA_COVERAGE';
export const SET_MEDIA_COVERAGE = 'SET_MEDIA_COVERAGE';

//! Testimonial Videos
export const GET_TESTIMONIAL_VIDEOS = 'GET_TESTIMONIAL_VIDEOS';
export const SET_TESTIMONIAL_VIDEOS = 'SET_TESTIMONIAL_VIDEOS';

//! Partner
export const GET_PARTNER_DETAILS = 'GET_PARTNER_DETAILS';
export const SET_PARTNER_DETAILS = 'SET_PARTNER_DETAILS';

//! Community Members
export const GET_COMMUNITY_MEMBERS = 'GET_COMMUNITY_MEMBERS';
export const SET_COMMUNITY_MEMBERS = 'SET_COMMUNITY_MEMBERS';

//! Blogs
export const GET_BLOGS = 'GET_BLOGS';
export const SET_BLOGS = 'SET_BLOGS';
export const GET_BLOG_BY_ID = 'GET_BLOG_BY_ID';
export const SET_BLOG_BY_ID = 'SET_BLOG_BY_ID';

//! Static Page
export const GET_TERMS_OF_USE = 'GET_TERMS_OF_USE';
export const SET_TERMS_OF_USE = 'SET_TERMS_OF_USE';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const GET_REFUND_POLICY = 'GET_REFUND_POLICY';
export const SET_REFUND_POLICY = 'SET_REFUND_POLICY';
export const GET_ABOUT_US = 'GET_ABOUT_US';
export const SET_ABOUT_US = 'SET_ABOUT_US';
export const GET_SHIPPING_POLICY = 'GET_SHIPPING_POLICY';
export const SET_SHIPPING_POLICY = 'SET_SHIPPING_POLICY';
